/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Box } from "@mui/material";
import React from "react";
import { useState } from "react";
import useGetImage from "../../common/hooks/useGetImage";
import { uploadUserAvatar } from "../service/userService";
import { errorMsg } from "../../helper/message";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import { useEffect } from "react";
import { useRef } from "react";
import LoadingPage from "../../common/components/common/LoadingPage";

const AvatarUpload = (props) => {
  const { control, name, watch } = props;
  const url = watch(name);
  const [loading, setLoading] = useState(false);
  const { handleGetUrlImage, urlImage, loadingImage } = useGetImage();
  const { t } = useTranslation("common");
  const handleUploadFile = async ({ target: { files } }, field) => {
    try {
      setLoading(true);
      const listType = ["image/png", "image/jpeg", "image/gif"];
      if (listType.includes(files[0].type)) {
        const formData = new FormData();
        formData.append("file", files[0]);
        const res = await uploadUserAvatar(formData);
        field.onChange(res?.data?.data.url);
      } else errorMsg(t("helperText.filesCanBeUploaded"));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      errorMsg(error);
    }
  };

  const uploadRef = useRef();

  useEffect(() => {
    url && handleGetUrlImage(url);
  }, [url]);

  return (
    <Box>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <div>
            {loadingImage || loading ? (
              <div
                style={{
                  position: "relative",
                  height: 150,
                  width: 150,
                  borderRadius: "50%",
                  border: "0.5px solid grey",
                }}
              >
                <LoadingPage />
              </div>
            ) : (
              <Avatar
                sx={{ ":hover": { cursor: "pointer" } }}
                style={{ width: 180, height: 180 }}
                src={urlImage}
                onClick={() => uploadRef?.current?.click()}
              />
            )}

            <input
              type="file"
              ref={uploadRef}
              accept=".jpg,.png,.jpeg,.gif"
              onChange={(e) => handleUploadFile(e, field)}
              className="absolute top-0 right-0 w-full h-full opacity-0 cursor-pointer"
              style={{ zIndex: 0, visibility: "hidden" }}
            />
          </div>
        )}
      />
    </Box>
  );
};

export default AvatarUpload;
